import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import OnePageMobile from "./OnePageMobile";
import OnePageDesktop from "./OnePageDesktop";

function OnePage({ app, config }) {
	const isMobile = useMediaQuery({ query: "(max-width: 980px)" });
	console.log("aaaaaa")
	return isMobile ? (
		<OnePageMobile app={app} config={config} />
	) : (
		<OnePageDesktop app={app} config={config} />
	);
}

OnePage.defaultProps = {
	app: null,
	config: {},
};

OnePage.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default OnePage;
